import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { z } from "zod";

import Left from "@repo/icons/default/Left";
import XCircle from "@repo/icons/default/XCircle";
import { CpsButton } from "corpus";

import {
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/ui/empty-state/empty-state";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { getDomainErrorContent } from "@/routes/custom-website/confirmation/domain-error-content";

import type { JSX } from "react";

interface ConfirmationErrorParams {
  action?: string;
  errorCode?: string;
}

const CustomWebsiteConfirmationErrorPage = (): JSX.Element => {
  const params: ConfirmationErrorParams = useSearch({
    from: "/custom-website/confirmation/error",
  });

  const navigate = useNavigate();

  const handleClick = async (): Promise<void> => {
    await navigate({
      to: "/home",
    });
  };

  const { title, description } = getDomainErrorContent({
    errorCode: params.errorCode,
    action: params.action,
  });

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Site personalizado" align="center" />
      </HeaderRoot>
      <Page>
        <div className="flex flex-col min-h-[75%] justify-center items-center">
          <EmptyStateRoot>
            <EmptyStateIcon icon={XCircle} fill="primary" />
            <EmptyStateTitle>{title}</EmptyStateTitle>
            <EmptyStateDescription>{description}</EmptyStateDescription>
          </EmptyStateRoot>
          <CpsButton
            className="my-8"
            fullWidth
            color="secondary"
            onClick={() => {
              void handleClick();
            }}
          >
            Voltar para Home
          </CpsButton>
        </div>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/custom-website/confirmation/error")({
  component: CustomWebsiteConfirmationErrorPage,
  validateSearch: z.object({
    action: z.string().optional(),
    errorCode: z.string().optional(),
  }),
});
